import { Image } from "@mantine/core";
import {
  IconCornerDownRight,
  IconMail,
  IconPhone,
  IconWorldWww
} from "@tabler/icons-react";
import { formatDateTime } from "../../../../../common/FormatDate/FormatDate";
import styles from "../../styles/PrintStyle.module.css";
import { SerialItemLKLR } from "../WarehouseOutWardActionV2";
interface PrintedInvoiceProps {
  dataLinhKienLR?: SerialItemLKLR[] | null;
  componentRef3: any;
  serialLKPrint?: string | null;
  dataOutWard?: any;
  isDonBanLe?: boolean;
}

const PrintWarehouseLKLR = ({
  dataLinhKienLR,
  componentRef3,
  serialLKPrint,
  dataOutWard,
  isDonBanLe,
}: PrintedInvoiceProps) => {
  // console.log("LoggdataLinhKienLR", dataLinhKienLR);
  // console.log("LoggdserialLKPrint", serialLKPrint);
  const dataTransaction = isDonBanLe ? dataOutWard?.tblInventoryTransactionModel
    : dataOutWard?.tblItemTransactionHeaderCommand;
  // Đây là state lưu địa chỉ Xã phường mới
  const useLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}"
  );

  // const spLR = (dataLinhKienLR && dataLinhKienLR.length > 0)
  //   ? dataLinhKienLR.find(
  //     (item) =>
  //       // Thêm .trim() để loại bỏ khoảng trắng và đảm bảo cả 2 đều là chuỗi
  //       String(item.serial).trim() === String(serialLKPrint).trim()
  //   )
  //   : undefined;
  // console.log("LoggspLR", spLR);


  //LẤY TÊN THÀNH PHỐ
  const getCityFromAddress = (address: string) => {
    if (!address) return ""; // Trường hợp address bị null hoặc undefined
    const parts = address?.split(" - ");
    return parts[parts.length - 1]; // Lấy phần cuối cùng làm tên thành phố
  };

  return (
    <div
      ref={componentRef3}
      className={styles.containerPrint}
      style={{
        height: "100%",
        margin: "0 auto",
        marginLeft: "40px",
        marginRight: "30px",
        // marginTop: "10px",
        fontFamily: `"Times New Roman", Times, serif`,
        position: "relative",
      }}
    >
      <div
        className={styles.contentMain}
        style={{
          // paddingTop: "10px",
          width: "100%",
          position: "relative",
          margin: "0 auto",
          marginRight: "20px",
          paddingRight: "20px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "2fr 1.5fr 2fr",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h6 style={{ margin: 0, fontSize: "10px", fontWeight: 600 }}>
              {useLoginHeader?.companyCode === "DVT"
                ? "Công Ty Cổ Phần HACOM Dịch Vụ Tốt"
                : " Công Ty Cổ Phần Đầu Tư Công Nghệ HACOM"}
            </h6>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "3px",
                alignItems: "center",
                fontSize: "10px",
                marginTop: "-5px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <IconPhone
                  stroke={2}
                  style={{
                    width: "10px",
                  }}
                />
                <p style={{ margin: 0, fontSize: "10px" }}>
                  {useLoginHeader?.companyCode === "DVT"
                    ? "18008091"
                    : "19001903"}
                  {" |"}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "3px",
                }}
              >
                <IconMail
                  stroke={2}
                  style={{
                    width: "10px",
                  }}
                />
                <p style={{ margin: 0, fontSize: "10px" }}>
                  {useLoginHeader?.companyCode === "DVT"
                    ? "info@dichvutot.vn"
                    : "dichvukhachhang@hacom.vn"}
                  {" |"}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "3px",
                }}
              // className={styles.text}
              >
                <IconWorldWww
                  stroke={2}
                  style={{
                    width: "10px",
                  }}
                />
                <p style={{ margin: 0, fontSize: "10px" }}>
                  {useLoginHeader?.companyCode === "DVT"
                    ? "dichvutot.vn"
                    : "hacom.vn"}
                </p>
              </div>
            </div>
          </div>
          <div style={{ paddingTop: "15px" }}>

          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
                gap: "3px",
                fontSize: "12px",
              }}
            // className={styles.warehouseCode}
            >
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  margin: 0,
                }}
              >
                Mã Xuất Kho:{" "}
              </p>{" "}
              {dataTransaction?.transactionCode}
            </div>
            <div
              // className={styles.warehouseCode}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
                gap: "3px",
                fontSize: "12px",
              }}
            >
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  margin: 0,
                }}
              >
                Mã Yêu Cầu Xuất Kho:{" "}
              </p>
              {dataTransaction?.sourceCode}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                width: "100%",
                fontSize: "14px",
              }}
            >
              <div>
                {getCityFromAddress(dataTransaction?.fromBranchAddress)} ngày{" "}
                <strong style={{ fontStyle: "italic" }}>
                  {formatDateTime(dataTransaction?.finishDate)}
                </strong>{" "}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: "5px",
            marginBottom: "15px",
          }}
        >
          <h1
            style={{
              fontWeight: "700",
              lineHeight: "1",
              fontSize: "18px",
              textAlign: "center",
              alignItems: "center",
              margin: 0,
            }}
          >
            PHIẾU IN LINH KIỆN LẮP RÁP
          </h1>
        </div>
        {/* <div
          style={{
            marginTop: "10px",
            marginBottom: "25px",
          }}
        >
          <p
            style={{
              lineHeight: "1",
              fontSize: "17px",
              alignItems: "center",
              margin: 0,
            }}
          >
            Sản phẩm : {spLR?.itemName || ""} - Serial: {spLR?.serial || ""}
          </p>
        </div> */}

        {/* table sản phẩm */}
        <div
          // className={styles.ProductMain}
          style={{
            width: "100%",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid black",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid black",
                  }}
                >
                  STT
                </th>
                <th
                  style={{
                    width: "40px",
                    border: "1px solid black",
                  }}
                >
                  Mã Hàng
                </th>
                <th
                  style={{
                    width: "20px",
                    border: "1px solid black",
                  }}
                >
                  Serial
                </th>
                <th
                  style={{
                    width: "370px",
                    border: "1px solid black",
                  }}
                >
                  Tên sản phẩm
                </th>

                <th
                  style={{
                    border: "1px solid black",
                    width: "150px",
                  }}
                >
                  Thời gian BH
                </th>
              </tr>
            </thead>
            {(() => {
              const arr = dataLinhKienLR ?? [];
              const norm = (s?: any) => String(s ?? "").trim();
              const bySerial = new Map(arr.map((it) => [norm(it.serial), it]));
              const children = arr.reduce((m, it) => {
                const p = norm(it.parentSerial);
                if (p) (m.get(p) || m.set(p, []).get(p))!.push(it);
                return m;
              }, new Map<string, SerialItemLKLR[]>());
              const out: SerialItemLKLR[] = [];
              const push = (it: SerialItemLKLR) => {
                out.push(it);
                (children.get(norm(it.serial)) || []).forEach(push);
              };
              arr.forEach((it) => {
                const p = norm(it.parentSerial);
                if (!p || !bySerial.has(p)) push(it);
              });
              arr.forEach((it) => !out.includes(it) && push(it));
              const base: React.CSSProperties = { border: "1px solid black" };

              return (
                <tbody>
                  {out.map((item, i) => {
                    const isParent =
                      String(item.serial ?? "").trim() === String(serialLKPrint ?? "").trim();
                    const isChild = !!(item.parentSerial && String(item.parentSerial).trim() !== "");
                    return (
                      <tr
                        key={item.serial || i}
                        style={isParent ? { backgroundColor: "#f6f9f0", fontWeight: 700 } : {}}
                      >
                        <td style={{ ...base, textAlign: "center" }}>{i + 1}</td>
                        <td style={{ ...base, textAlign: "center" }}>{item.itemCode}</td>
                        <td style={{ ...base, textAlign: "center" }}>{item.serial}</td>
                        <td style={{ ...base, paddingLeft: isChild ? 18 : 5 }}>
                          {isChild ? <IconCornerDownRight size={14} style={{ marginRight: 6, verticalAlign: "middle" }} />
                            : null}
                          {item.itemName}
                        </td>
                        <td style={{ ...base, textAlign: "end" }}>
                          {item?.warrantyVendor ? `${item.warrantyVendor} tháng` : ""}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              );
            })()}
          </table>
        </div>
      </div>
      <div
        // className={styles.backgroudHacom}
        style={{
          position: "absolute",
          width: "100%",
          zIndex: -1,
          opacity: 0.1,
          top: "40%",
        }}
      >
        <Image
          radius="md"
          src="https://hanoicomputercdn.com/media/lib/17-10-2024/logo-hacom-since-2001_new.png"
          // className={styles.logo}
          style={{
            width: "90%",
            margin: "0 auto",
          }}
        />
      </div>
    </div>
  );
};

export default PrintWarehouseLKLR;
